import React from 'react';

import {useMaskedImage} from '../MaskedImage';
import {useSafeImageSrc} from '../SafeImage';

const Icon = props => {
    const {className = '', icon, noIconClass, width, height, size, selected, disabled, error, margin, src, altSrc, color, onClick, onTransitionEnd, children} = props,
        checkedSrc = useSafeImageSrc(src, altSrc),
        maskedSrc = useMaskedImage(checkedSrc, color),
        style = {
            width: width ?? size ?? undefined,
            height: height ?? size ?? undefined,
            ...props.style,
            backgroundImage: maskedSrc ? `url('${maskedSrc}')` : null,
        };

    if (margin) {
        style.margin = margin;
    }

    return (
        <span
            className={[noIconClass ? '' : 'icon', className, icon, selected ? 'selected' : '', disabled ? 'disabled' : '', error ? 'error' : ''].join(' ')}
            style={style}
            onClick={onClick}
            onTransitionEnd={onTransitionEnd}>
            {children}
        </span>
    );
};

export default Icon;
